import { Address } from '../../../models/users/dto/address';
import { BeneficiaryTrustee } from './beneficiary-trustee';
import { BeneficiaryEntityTypeEnum } from '../enums/beneficiary-entity-type.enum';
import { BeneficiaryEntityType } from './beneficiary-entity-type';
import { Deserializable } from '../../../models/protocols/deserializable';
import { BeneficiaryRelationshipToMemberType } from './beneficiary-relationship-to-member-type';
import { BeneficiaryTypeEnum } from '../enums/beneficiary-type.enum';
import { BeneficiaryType } from './beneficiary-type';

export class Beneficiary implements Deserializable {
  public id: number | null = null;
  public accountId!: number;
  public memberBeneficiaryId: number | null = null;
  public typeId!: BeneficiaryTypeEnum;
  public type!: BeneficiaryType;
  public entityTypeId!: BeneficiaryEntityTypeEnum;
  public entityType!: BeneficiaryEntityType;
  public relationshipToMemberId: number | null = null;
  public relationshipToMember!: BeneficiaryRelationshipToMemberType;
  public relationshipToMemberOtherDescription: string | null = null;
  public firstName: string | null = null;
  public middleName: string | null = null;
  public lastName: string | null = null;
  public socialInsuranceNumber: string | null = null;
  public email: string | null = null;
  public phoneNumberCountryCode: string | null = null;
  public phoneNumber: string | null = null;
  public birthDate: string | null = null;
  public organizationName: string | null = null;
  public organizationPhoneNumberCountryCode: string | null = null;
  public organizationPhoneNumber: string | null = null;
  public address: Address | null = null;
  public sharePercentage: number | null = null;
  public contingentSharePercentage: number | null = null;
  public trustee: BeneficiaryTrustee | null = null;

  public onDeserialize(): void {}
}
